import { render, staticRenderFns } from "./Invoiceinventoryquery.vue?vue&type=template&id=19c80a56&scoped=true&"
import script from "./Invoiceinventoryquery.vue?vue&type=script&lang=js&"
export * from "./Invoiceinventoryquery.vue?vue&type=script&lang=js&"
import style0 from "./Invoiceinventoryquery.vue?vue&type=style&index=0&id=19c80a56&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c80a56",
  null
  
)

export default component.exports